(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/utils/react-help-utils/assets/javascripts/components/async.js') >= 0) return;  svs.modules.push('/components/utils/react-help-utils/assets/javascripts/components/async.js');
"use strict";

function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

(function (svs) {
  const _React = React,
    Component = _React.Component,
    isValidElement = _React.isValidElement;
  class Async extends Component {
    constructor(props) {
      super(props);
      _defineProperty(this, "state", {
        element: null
      });
      props.promise.then(element => {
        if (!isValidElement(element)) {
          throw new Error('The promise must be resolved with a valid react element');
        }
        this.setState({
          element
        });
      });
    }
    render() {
      return this.state.element;
    }
  }
  svs.utils.reactHelpUtils.components.Async = Async;
})(svs);

 })(window);